import { Modal, ModalBody } from "reactstrap";
import welcomeBanner from "../../../assets/img/photos/firstEvent3.jpg";


function WelcomeEventModal({ isOpen, dismissModal, takeAction }) {
    return <Modal isOpen={isOpen} toggle={dismissModal} className="medium full" >
        <img src={welcomeBanner} alt="Welcome" style={{ height: 300, width: '100%', objectFit: 'cover', filter: 'brightness(1.5)' }} />
        <div className="modalHeader">
            <button className="contained" onClick={dismissModal} style={{ position: 'absolute', right: 15, top: 15, padding: 7 }}><i className='las la-times white'></i></button>
        </div>
        <ModalBody className="modalBody">
            <div className="p-50 text-c pt-30">
                <h1>Congratulations!</h1>
                <h1 className="mb-20">You've created your first event.</h1>
                <p className="mb-40" style={{ maxWidth: 500 }}>
                    Want to explore on your own or take a quick guided tour?
                </p>
                <div className="flex jcc gap20">
                    <button className="outline minWidth" onClick={dismissModal}>I'll figure it out</button>
                    <button className="prim minWidth" onClick={takeAction}>Show me around</button>

                </div>
            </div>
        </ModalBody>
    </Modal>
}

export default WelcomeEventModal;